// js/custom-element/section/blog/blog-post-header.js
(function() {
  const init = function() {
    if (!window.customElements.get("blog-post-header")) {
      var BlogPostHeader = class extends HTMLElement {
        async connectedCallback() {
          const image = this.querySelector(".article__image");
          if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            image.removeAttribute("reveal");
          } else {
            await window.imageLoaded(image);
            image.animate({ opacity: [0, 1], transform: ["scale(1.1)", "scale(1)"] }, { duration: 500, fill: "forwards", easing: "cubic-bezier(0.65, 0, 0.35, 1)" });
          }
        }
      };
      window.customElements.define("blog-post-header", BlogPostHeader);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();